/**
 * CurrencyFlag
 *
 * Para birimi koduna göre ülke/bölge bayrağı SVG'si render eder.
 * country-flag-icons (React/3x2) paketini kullanır.
 */
import * as Flags from 'country-flag-icons/react/3x2';

/** Para birimi kodu → ISO 3166-1 alpha-2 ülke kodu eşlemesi */
const CURRENCY_TO_COUNTRY: Record<string, string> = {
  PLN: 'PL', // Polish Złoty → Polonya
  USD: 'US', // US Dollar → Amerika
  EUR: 'EU', // Euro → Avrupa Birliği
  GBP: 'GB', // British Pound → Birleşik Krallık
  GBX: 'GB', // Pence Sterling → Birleşik Krallık
  CHF: 'CH', // Swiss Franc → İsviçre
  CAD: 'CA', // Canadian Dollar → Kanada
  AUD: 'AU', // Australian Dollar → Avustralya
  JPY: 'JP', // Japanese Yen → Japonya
  CNY: 'CN', // Chinese Yuan → Çin
  SEK: 'SE', // Swedish Krona → İsveç
  NOK: 'NO', // Norwegian Krone → Norveç
  DKK: 'DK', // Danish Krone → Danimarka
  CZK: 'CZ', // Czech Koruna → Çek Cumhuriyeti
  HUF: 'HU', // Hungarian Forint → Macaristan
  TRY: 'TR', // Turkish Lira → Türkiye
};

interface CurrencyFlagProps {
  /** ISO 4217 para birimi kodu (ör. "USD", "EUR", "PLN") */
  currency: string;
  /** CSS class (ör. boyutlandırma için) */
  className?: string;
}

/**
 * Para birimi için bayrak SVG'si döner.
 * Bilinmeyen para birimi kodları için null döner.
 */
export default function CurrencyFlag({ currency, className = 'w-6 h-4' }: CurrencyFlagProps) {
  const countryCode = CURRENCY_TO_COUNTRY[currency.toUpperCase()];
  if (!countryCode) return null;

  // Flags nesnesi üzerinden dinamik erişim
  const FlagComponent = (
    Flags as Record<string, React.ComponentType<React.SVGProps<SVGSVGElement>>>
  )[countryCode];
  if (!FlagComponent) return null;

  return <FlagComponent className={className} aria-label={currency} />;
}
